import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function AmpStoriesIcon(props: IconProps) {
    return <Icon {...props} iconKey={"amp_stories"}/>
}
